export enum EnvironmentType {
  Production = 'prd',
  Test = 'tst'
}
